import { render, staticRenderFns } from "./ChannelAuthenticationStepByStepView.vue?vue&type=template&id=5a20e23b&scoped=true&"
import script from "./ChannelAuthenticationStepByStepView.vue?vue&type=script&lang=js&"
export * from "./ChannelAuthenticationStepByStepView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAuthenticationStepByStepView.vue?vue&type=style&index=0&id=5a20e23b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a20e23b",
  null
  
)

export default component.exports